import { Component } from '@angular/core';
import { PartitionsTreeBase } from '../partitions-tree-base/partitions-tree-base';

@Component({
    selector: 'app-partitions-tree-card',
    templateUrl: './partitions-tree-card.component.html',
    styleUrls: ['./partitions-tree-card.component.scss']
})
export class PartitionsTreeCardComponent extends PartitionsTreeBase {
    constructor( ) {
        super();
    }
}
